import { create } from 'zustand'

interface ModalProppitState {
  modalProppit: {
    isOpen: boolean
    onSuccess?: () => void
  }
  setModalProppit: (modalProppit: {
    isOpen: boolean
    onSuccess?: () => void
  }) => void
  reset: () => void
}

const initialState = {
  modalProppit: {
    isOpen: false
  }
}

export const useModalProppitStore = create<ModalProppitState>()((set) => ({
  ...initialState,
  setModalProppit: (modalProppit) => set({ modalProppit }),
  reset: () =>
    set({
      modalProppit: initialState.modalProppit
    })
}))
